export default "__VITE_ASSET__DgtQaW$Y__"